import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Plus } from "lucide-react";
import { HIDDEN, parseAuto } from "./cellUtils";
import { t } from "@/lib/i18n";

export function AddRowDialog({ open, onOpenChange, collection, data, onSave, busy }) {
  const baseCols = (data?.columns || []).filter((c) => c !== "_id" && !(data?.rows || []).some((r) => r[c] === HIDDEN));
  const cols = collection === "users" ? [...baseCols, "password"] : baseCols;
  const [values, setValues] = useState({});
  const [extra, setExtra] = useState("");

  useEffect(() => { if (open) { setValues({}); setExtra(""); } }, [open]);

  const submit = () => {
    const doc = {};
    Object.entries(values).forEach(([k, v]) => { if (v !== "") doc[k] = k === "password" ? v : parseAuto(v); });
    if (extra.trim()) doc[extra.trim()] = "";
    onSave(doc);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="admin-add-row-dialog">
        <DialogHeader><DialogTitle>{t("Nuova riga in “")}{collection}”</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">{t("Numeri, true/false e JSON (")}{"{…}"} {t("/ […]) vengono riconosciuti in automatico.")} {collection === "users" && t("La password viene salvata criptata.")}</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {cols.map((c) => (
            <div key={c} className="space-y-1">
              <Label className="text-xs font-mono-j">{c}</Label>
              <Input type={c === "password" ? "password" : "text"} value={values[c] || ""} onChange={(e) => setValues({ ...values, [c]: e.target.value })} data-testid={`admin-add-field-${c}`} />
            </div>
          ))}
          <div className="space-y-1">
            <Label className="text-xs">{t("Nuova colonna (facoltativa)")}</Label>
            <Input value={extra} onChange={(e) => setExtra(e.target.value)} placeholder={t("nome_campo")} data-testid="admin-add-extra-column" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="admin-add-cancel-btn">{t("Annulla")}</Button>
          <Button onClick={submit} disabled={busy} className="gap-2" data-testid="admin-add-save-btn"><Plus className="h-4 w-4" /> {t("Salva riga")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
